export class AccountConstants {
  public static closed_account_translation: any = {
    accident: "siniestro",
    decease: "fallecimiento",
    dation: "dación",
    recovered: "recuperación",
    natural_termination: "terminación natural",
    early_termination: "terminación anticipada",
    fraud: "fraude",
    cancellation: "cancelación",
  };
}
